import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const AdminRoute = ({ children }) => {
  const UsersProfile = useSelector((state) => state.UsersProfile);
  const userData = UsersProfile?.personalDetails?.data;

  // Allow both admin (is_admin = true or 1) and sub-admin (role = "sub_admin")
  const isAdmin = !!userData?.is_admin;
  const isSubAdmin = userData?.role === "sub_admin";

  if (!isAdmin && !isSubAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;
